import { render, staticRenderFns } from "./rotaLista.vue?vue&type=template&id=6e20338f&scoped=true"
import script from "./rotaLista.vue?vue&type=script&lang=js"
export * from "./rotaLista.vue?vue&type=script&lang=js"
import style0 from "./rotaLista.vue?vue&type=style&index=0&id=6e20338f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20338f",
  null
  
)

export default component.exports